"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/switch/style/index.js
// module id = 521
// module chunks = 1